<template>
  <el-select @change="handleChange" popper-class="cust-select-poper" v-model="accessType"  style="width: 100%">
        <el-option :label="$t('ALL_OPTION')" value="ALL" >
            <p >
                <el-radio class="mr_10 label-hidden" label="ALL" v-model="accessType" ></el-radio>
                <span class="option-label">{{$t('ALL_OPTION')}} </span>
            </p>
            <template v-if="$i18n.locale === 'en'">
                <p class="mr_25 desc" >
                    User has access to all entities content across all tiles.
                </p>
            </template>
            <template v-else>
                <p class="mr_25 desc">用户可以访问所有实体及所有功能版块中的内容。</p>
            </template>
           
        </el-option>
        <el-option  :label="$t('SPECIFIC_OPTION')" value="SPECIFIC">
            <p >
                <el-radio class="mr_10 label-hidden" label="SPECIFIC"  v-model="accessType"></el-radio>
                <span class="option-label">{{$t('SPECIFIC_OPTION')}}</span>
            </p>
              <template v-if="$i18n.locale === 'en'">
                <p class="mr_25 desc">
                  User has access to each tile content based on the authorised client 
                </p >
                <p class="mr_25 desc">entities, and all Audit Confirmations and Client Admin content.</p>
            </template>
            <template v-else>
                  <p class="mr_25 desc">用户可以访问所授权实体在各功能版块中的内容，以及</p>
                    <p class="mr_25 desc">所有“审计函证”和“客户项目管理”内容。</p>
            </template>
           
        </el-option>
    </el-select>
</template>

<script>
export default {
    props:{
        initData:{
            type:String,
            default:""
        },
    },
    data(){
        return{
            accessType:"",
        }
    },
    watch:{
       initData:{
            handler:function(val){
                this.accessType =val;
            },
            immediate:true
       } 
    },
    methods:{
        handleChange(){
            this.$emit("change", this.accessType)
        }
    }
}
</script>

<style scoped>
    .mr_10{
    margin-right:10px;
    }
    .mr_25{
        margin-left:25px;
    }
    .desc{
        color:#636363;
        font-weight:400;
    }
    ::v-deep .label-hidden .el-radio__label{
        display: none;
    }
</style>